import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [usage, setUsage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for token and user data on app load
    // const token = localStorage.getItem('token');
    const storedUser = localStorage.getItem('user'); // Optional: if you store user data too

    if (storedUser) {
        // Option A: Just assume logged in if token exists (Simpler)
        // You might want to decode the JWT here to get user info if you didn't store the user object
        // setUser(storedUser ? JSON.parse(storedUser) : { token });
        setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  const login = (userData) => {
    setUser(userData);
    // Ensure data is saved so it persists on refresh
    // localStorage.setItem('token', userData.token);
    // Ideally store non-sensitive user info (name, email) in LS too so you can show it immediately
    localStorage.setItem('user', JSON.stringify(userData)); 
  };

  const logout = () => {
    setUser(null);
    // localStorage.removeItem('token');
    localStorage.removeItem('user');
  };

  if (loading) {
      return <div className="min-h-screen bg-[#0a0a0a] text-white flex items-center justify-center">Loading...</div>;
  }

  return (
    <AuthContext.Provider value={{ user , setUser , login, logout , usage , setUsage }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);